import actions from "./actions";
import mutations from "./mutation";
export default {
  namespaced: true,
  state: {
    allFeedbackSurvey: [],
    selectedRow: null,
    surveyAnswers: null,
    tableLoading: false,
    currentPage: 1,
    perPage: 5,
    searchQuery: "",
    total: 0,
    archived: false,
  },
  actions,
  mutations,
};
